<template>
  <TWModal
    :title="$t('groups.createTeam')"
    :loading="loading"
    :show="show"
    @close="handleClose"
    :allow-outside-click-to-close="false"
  >
    <template v-slot:content>
      <div>
        <form data-vv-scope="group-create">
          <div class="mb-4">
            <label class="mb-1 inline-block" for="group-name">{{
              $t("groups.name")
            }}</label>
            <TextInput
              id="group-name"
              placeholder="e.g. Finance"
              :value="group.name"
              v-model="group.name"
              :has-error="errors.has('group-create.name')"
              data-ec="create_group_modal"
              data-et="group_name_input"
              v-validate="'required'"
              data-vv-name="name"
              data-vv-as="name"
              data-hj-suppress
            />
            <ValidationError v-show="errors.has('group-create.name')">
              <template v-slot:text>
                {{ errors.first("group-create.name") }}
              </template>
            </ValidationError>
          </div>
          <div class="mb-4">
            <label class="mb-1 inline-block">{{ $t('groups.invite-members-to-team') }}</label>
            <UserSelectInput
                v-model="group.users"
                @select="handleUserSelected"
                @remove="handleUserRemoved"
            ></UserSelectInput>
          </div>
        </form>
      </div>
    </template>
    <template v-slot:controls>
      <div class="flex w-full justify-between">
        <button
          type="button"
          id="cancel-create-group-button"
          class="tw-button mr-2"
          @click="handleClose"
          data-ec="create_group_modal"
          data-et="btn_cancel"
        >
          <XMarkIcon />
          <span>{{ $t("functional.cancel") }}</span>
        </button>
        <button
          type="button"
          id="create-group-button"
          class="tw-button tw-button-cta"
          @click="handleCreateGroup"
          data-ec="create_group_modal"
          data-et="btn_save"
        >
          <CheckIcon />
          <span>{{ $t("groups.saveTeam") }}</span>
        </button>
      </div>
    </template>
  </TWModal>
</template>

<script>
import TWModal from '@/components/tailwind/Modal.vue';
import TextInput from '@/components/tailwind/forms/TextInput.vue';
import ValidationError from '@/components/tailwind/forms/ValidationError.vue';
import UserSelectInput from '@/views/components/UserSelectInput.vue';
import { logAmplitudeEvent } from '@/utils/analytics';
import { CheckIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'CreateGroupModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ValidationError,
    TWModal,
    TextInput,
    UserSelectInput,
    CheckIcon,
    XMarkIcon,
  },
  data() {
    return {
      group: {
        name: null,
        users: [],
      },
      loading: false,
    };
  },
  methods: {
    handleUserSelected() {
      logAmplitudeEvent('create_group_modal--added_user_to_group_via_dropdown');
    },
    handleUserRemoved() {
      logAmplitudeEvent('create_group_modal--removed_user_from_group_via_dropdown');
    },
    handleCreateGroup() {
      this.$validator.validateAll('group-create').then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store
            .dispatch('groups/CREATE', {
              name: this.group.name,
              users: this.group.users.map(user => user.id),
            })
            .then(() => {
              this.resetComponent();
              this.$emit('group-created');
              this.$emit('close');
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleClose($event) {
      if ($event && $event.target.classList.contains('multiselect__input')) {
        document.getElementById('create-group-button').focus();
        return;
      }

      this.resetComponent();
      this.$emit('close');
    },
    resetComponent() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
  },
};
</script>

<style scoped></style>
